import { HomeIcon, PeopleIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useState } from "react";
import QuanHeGiaDinhHocSinh from "./QuanHeGiaDinhHocSinh";
import AnhChiEmPage from "./anh-chi-em/AnhChiEmPage";

interface HocSinh {
    id: number;
    ho_ten: string;
    ma_hs: string;
    ma_tn: string;
    ngay_sinh: string;
    dm_gioitinh_id: number;
    gioi_tinh: string;
    ten_he: string;
    ten_lop: string;
    trang_thai: string;
}

interface Props {
    hocSinh: HocSinh;
}

const QuanHeGiaDinhLayout: React.FC<Props> = ({ hocSinh }) => {
    const [selectedTab, setSelectedTab] = useState<"parents" | "ace">("parents");

    return (
        <Box>
            <UnderlineNav aria-label="tabs">
                <UnderlineNav.Item
                    icon={HomeIcon}
                    aria-current={selectedTab === "parents" ? "page" : undefined}
                    onClick={() => setSelectedTab("parents")}
                >
                    Phụ huynh
                </UnderlineNav.Item>
                {/* <UnderlineNav.Item
                    icon={PeopleIcon}
                    aria-current={selectedTab === "ace" ? "page" : undefined}
                    onClick={() => setSelectedTab("ace")}
                >
                    Anh chị em
                </UnderlineNav.Item> */}
            </UnderlineNav>
            <Box>
                {selectedTab === "parents" && <QuanHeGiaDinhHocSinh hocSinh={hocSinh} />}
                {selectedTab === "ace" && <AnhChiEmPage hocSinh={hocSinh} />}
            </Box>
        </Box>
    );
};

export default QuanHeGiaDinhLayout;
